import { defineAsyncComponent } from 'vue';

export const billableTimeMicroFrontends = {
	BillableTimeTypeDropdown: defineAsyncComponent(
		() => import('./components/BillableTimeTypeDropdown.vue')
	),
};
